module.exports = __webpack_public_path__ + "img/P2.60414b23.jpg";